<template>
  <div class="col table-responsive">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th scope="col" class="multi-line-header">Produktionsdatum</th>
          <th scope="col" class="multi-line-header">Operator</th>
          <th scope="col" class="multi-line-header">Chargen Nr.</th>
          <th scope="col" class="multi-line-header">Ablaufdatum</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry, tableId) in entries" :key="tableId">
          <td>{{ entry.dateInProduction.replace("T", " ") }}</td>

          <td>{{ entry.username }}</td>

          <td>{{ entry.siliconBatch }}</td>

          <td v-if="checkDate(entry.dateInProduction, entry.expiryDate)">
            {{ entry.expiryDate.split("T")[0] }}
          </td>
          <td class="expired" v-else>
            {{ entry.expiryDate.split("T")[0] }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from "vue";
import { instance as axios } from "@/services/axios";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
});

const entries = ref([]);

const checkDate = (dateOne, dateTwo) => {
  return Date.parse(dateOne) < Date.parse(dateTwo);
};

const fetchData = async (url) => {
  try {
    const { data } = await axios.get(url);
    entries.value = data;
  } catch (error) {
    if (error.response) {
      console.log("HTTP Fehler:", error.response.status);
    } else {
      console.log("Netzwerkproblem:", error.message);
    }
  }
};

onMounted(() => {
  fetchData(props.url);
});
</script>

<style scoped>
@media (max-width: 768px) {
  th {
    white-space: normal;
    word-wrap: break-word;
  }
}

.expired {
  color: darkorange !important;
}
</style>
